export default "__VITE_ASSET__aBb3FUQM__"